import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  list: {
    width: '100%',
    maxWidth: '300px',
    maxHeight: '200px',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    width: '100%'
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  multField: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '5px'
  },

  optionsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 8,
    flexWrap: 'wrap',
    '& .MuiFormControlLabel-root': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      margin: '0 !important'
    }
  },
  radio: {
    '&.MuiRadio-root': {
      color: theme.palette.blue_300.main,
      padding: 0,
      marginRight: 4
    },
    '& .MuiSvgIcon-root': {
      fontSize: 18
    },
    '&.Mui-checked': {
      color: theme.palette.blue_300.main
    }
  }
}))
